/**
 * @description: 员工列表
 * @author: fire
 * @update: cyp (2017-3-27 11:45)
 * @update: hwx
 * @update: lyr
 */
<template>
    <div class="staff-list-wrap">
        <div class="list" v-show="!showGroup">
            <div class="row row-margin">
                <label class="list-label-4">服务门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="staff_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">职位:</label>
                <div class="col-md-2">
                    <input class="form-control" v-model="job" placeholder="输入职位">
                </div>
                <div class="ct-col pb-tit-sel">
                    <select class="form-control" ref="query_conditions">
                        <option value="name">姓名</option>
                        <option value="mobile">手机号</option>
                        <option value="work_number">员工工号</option>
                    </select>
                </div>
                <div class="col-md-2 pb-con-val">
                    <input type="text" class="form-control" v-model="search_info" :placeholder="employeeinput">
                </div>
                <label class="list-label-2">状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="staff_status">
                        <option value="1">启用</option>
                        <option value="-1">禁用</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-2">组别:</label>
                <div class="col-md-2 ct-col">
                    <el-input v-model="group_name" 
                        class="el-ellipsis" 
                        clearable 
                        placeholder="请选择组别" 
                        @focus="enterGroup" 
                        @clear="groupDeal"
                        size="small"
                        :disabled="shop_id=='0'">
                    </el-input>
                </div>
                <div class="pull-right">
                    <a href="https://vodonline.oss-cn-beijing.aliyuncs.com/Download/userImportTemplate.xls" class="btn btn-flat btn-middle btn-orange">员工资料模板下载</a>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="staffXlsFun">员工资料模板导入</button>
                    <input type="file" @change="uploadStaffXls($event)" id="staffXlsFile" ref="staffXlsFile">
                    <button type="button" class="btn bg-orange btn-flat btn-wide" @click="queryemloyee">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="exportList">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table ref="employee_manage_table" class="table table-bordered table-hover" data-pagination="true"></table>
            </div>
        </div>

        <!-- 组别列表 -->
        <div class="page-group" v-show="showGroup">
            <h2>请选择组别</h2>
            <div class="page-group-search pull-right">
                <el-input placeholder="请输入组别名称" v-model="group_name"></el-input>
                <img src="../../assets/images/group_search.png" @click="groupList">
            </div>
            <!-- 列表 -->
            <div class="page-group-list">
                <el-checkbox :indeterminate="group_sign" v-model="group_all" @change="groupAll">全选</el-checkbox>
                <el-checkbox-group v-model="group_ids" @change="groupChange">
                    <el-checkbox v-for="item in group_list" :key="item.group_id" :label="item.group_id">{{item.group_name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div class="page-group-btns">
                <el-button @click="groupBack">返回</el-button>
                <el-button type="primary" @click="groupSub">确定</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                employeeinput: '请输入姓名',
                paramsdatas: "",
                search_field: "name",
                search_info: "",
                job: "",
                userinfo: {},
                shop_id: '',

                showGroup: false,
                group_sign: false,
                group_all: false,
                group_name: '',
                group_ids: [],
                c_group_ids: [],
                group_list: [],
            }
        },
        mounted: function() {
            let _this = this;
            _this.getShop();
            $(_this.$refs.query_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.search_field = $(this).val();
                if(_this.search_field == 'name') {
                    _this.employeeinput = '请输入姓名';
                } else if(_this.search_field == 'mobile') {
                    _this.employeeinput = '请输入手机号';
                } else if(_this.search_field == 'work_number') {
                    _this.employeeinput = '请输入工号';
                }
            });
            $(_this.$refs.staff_status).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            })
        },
        methods: {
            // 获取门店数据
			getShop: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						let arr = [];
                        $.each(res.data.response.result, function(k, v) {
                            arr.push({ id: v.id, text: v.name });
                        });
                        $(_this.$refs.staff_shop).select2({
                            data: arr,
                            allowClear: false,
                            width: '100%'
                        }).on("select2:select", function(e) {
                            _this.shop_id = e.params.data.id
                            if (_this.shop_id == '0') {
                                _this.group_name = ''
                                _this.group_ids = []
                            }
                        });
                        $(_this.$refs.staff_shop).val(res.data.response.result[1].id).trigger('change');
                        _this.shop_id = res.data.response.result[1].id;
                        _this.innitable();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
            innitable: function() {
                let _this = this;
                $(_this.$refs.employee_manage_table).bootstrapTable('destroy');
                $(_this.$refs.employee_manage_table).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    ajax: function(params) {
                        _this.paramsdatas = params;
                        _this.getemployeedata(params, _this);
                    },
                    sidePagination: "server",
                    pagination: true,
                    columns: [{
                        width: "14%",
                        field: "shop_name",
                        title: "服务门店"
                    }, {
                        width: "10%",
                        field: "group_name",
                        title: "组别"
                    }, {
                        width: "10%",
                        field: "name",
                        title: "姓名"
                    }, {
                        width: "10%",
                        field: "work_number",
                        title: "工号"
                    }, {
                        width: "14%",
                        field: "mobile",
                        title: "手机号"
                    }, {
                        width: "14%",
                        field: "job",
                        title: "职位"
                    }, {
						width: "14%",
						field: "status",
						title: "状态",
						formatter: function(value, row) {
							return value == "1" ? "启用" : "禁用";
						}
					}, {
						width: "14%",
						title: "操作",
						events: {
							'click .status': function(e, value, row, index) {
								let statustxt = "";
                                if(row.status == 1) {
                                    statustxt = "确定禁用?"
                                } else {
                                    statustxt = "确定启用?"
                                }
                                layer.confirm(statustxt, {
                                    btn: ['确定', '取消'], //按钮
                                }, function() {
                                    _this.statusStaff(row.id);
                                });
							},
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delStaff(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							let statusText = (row.status == 1) ? '禁用' : '启用';
							return '<span class="text-blue status">'+ statusText +'</span><span class="text-blue del">删除</span>';
						},
					}],
                });
            },
            getemployeedata : function(params, _this) {
                let pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": pageNumber,
                            "page_size": "10",
                            "shop_id": $(_this.$refs.staff_shop).val(),
                            "search_field": _this.search_field,
                            "search_info": _this.search_info || "",
                            "job": _this.job || "",
                            "status": $(_this.$refs.staff_status).val(),
                            "group_id": _this.group_ids
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_status'] == 200) {
                            params.success({
                                total: data['response']['result']['count'],
                                rows: data['response']['result']['user_info']
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            queryemloyee: function() {
                this.innitable();
            },
            // 禁用、启用
			statusStaff(id) {
				const _this = this;
				Vue.axios.post('User/upStatus', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg(res.data.response.error_msg);
                        _this.innitable();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
			},
            // 删除
			delStaff(id) {
				const _this = this;
				Vue.axios.post('User/delete', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.msg('删除成功');
                        _this.innitable();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
			},
            // 导入xls文件
            staffXlsFun: function() {
                this.$refs.staffXlsFile.click();
            },
            // 导入
            uploadStaffXls: function(e) {
                let _this = this;

                let formData = new FormData();
                formData.append("userFile", $("#staffXlsFile")[0].files[0]);
                // 清除file
                let obj = document.getElementById('staffXlsFile');
                obj.value = '';

                $.ajax({
                    type: "post",
                    dataType: "json",
                    processData: false,
                    contentType: false,
                    url: Vue.ctUrl + "User/importUserData",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: formData,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg('导入成功');
                            $(_this.$refs.employee_manage_table).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.open({
                                type: 1,
                                title: '导入失败，数据错误，请修正数据后重新导入！',
                                skin: 'import-err',
                                area: ['700px', ''],
                                content: data.response.error_msg
                            })
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 进入选择组别
            enterGroup() {
                this.c_group_ids = this.group_ids;
                this.groupList();
                this.showGroup = true;
            },
            // 清空组别
            groupDeal() {
                this.group_all = false;
                this.group_sign = false;
                this.group_ids = [];
            },
            // 全选
            groupAll(val) {
                const _this = this;
                let ids = [];
                _this.group_list.forEach(v => {
                    ids.push(v.group_id);
                });
                _this.group_ids = val ? ids : [];
                _this.group_sign = false;
            },
            // 选中
            groupChange(val) {
                let count = val.length;
                this.group_all = count === this.group_list.length;
                this.group_sign = count > 0 && count < this.group_list.length;
            },
            // 返回
            groupBack: function() {
                this.group_ids = this.c_group_ids;
                this.showGroup = false;
            },
            // 确定组别
            groupSub() {
                const _this = this;
                let arr = [];
                _this.group_list.forEach(function(item) {
                    _this.group_ids.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.group_name = arr.join(',');
                this.showGroup = false;
            },
            // 获取组别
            groupList() {
                const _this = this;

                Vue.axios.post('User/getGroupSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.staff_shop).val(),
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.group_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 导出
            exportList() {
                window.location.href = Vue.ctUrl + "User/exportList" +
                    "?shop_id=" + $(this.$refs.staff_shop).val() +
                    "&search_field=" + this.search_field +
                    "&search_info=" + (this.search_info || "") +
                    "&job=" + (this.job || "") +
                    "&status=" + $(this.$refs.staff_status).val() +
                    "&group_id=" + this.group_ids
                layer.msg("导出成功！")
            },
        }
    }
</script>

<style lang="less">
    .staff-list-wrap {
        .pb-tit-sel {
            float: left;
            width: 95px;
            padding: 0;
        }
        .pb-con-val {
            padding-left: 0;
            margin-left: -1px;
        }
        .pull-right {
            button {
                margin: 0 0 0 30px;
            }
            input {
                display: none;
            }
        }
        .page-group {
            .el-checkbox {
                margin-bottom: 20px;
            }
        }
    }
</style>
